export const APP_NAME = 'Tene Agricultural Solutions Pvt. Ltd.'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const Number_Of_attempts = 10